export default __webpack_public_path__ + "static/media/motherSeven.141ae2cf.jpeg";